import { useMutation, useQuery } from '@tanstack/react-query';
import { AssessmentCreateSchema } from '@opp/shared';
import { createAssessment as createAssessmentService, listAssessments as listAssessmentsService } from '@/services/assessmentService';
import { CustomError } from '@/utils/CustomError';
import { AssessmentTabValue } from '@/utils/assesmentLabels';


export function useCreateAssessment() {
  return useMutation({
    mutationFn: async (data: AssessmentCreateSchema) => createAssessmentService(data),
    onSuccess: (response) => {
      return response;
    },  
  });
}

export function useAssessmentList(
  status: AssessmentTabValue, 
  organizationId: string, 
  page: number = 1,
  perPage: number = 10,
  storeId?: string,
  filters?: {
    patientId?: string;
    patientName?: string;
    patientDocument?: string; // compat
    patientPhone?: string;
    responsibleId?: string;
    classificationIds?: string[];
    search?: string;
  },
  sort?: {
    orderBy?: 'DATE' | 'CREATED' | 'UPDATED' | 'NAME';
    orderDirection?: 'asc' | 'desc';
  },
  /**
   * Força refetch criando uma queryKey nova, evitando reaproveitar cache.
   * Útil quando o usuário clica "Aplicar" sem mudar campos, por exemplo.
   */
  cacheBuster: number = 0,
) {
  return useQuery({
    queryKey: ['assessmentList', status, organizationId, page, perPage, storeId, filters, sort, cacheBuster],
    queryFn: async () => {
      const response = await listAssessmentsService(status, organizationId, page, perPage, storeId, filters, sort);
      
      if (response.error || response.validation) {
        throw new CustomError(
          response.message || 'Erro ao buscar lista de atendimentos',
          response.errorCode || 'INTERNAL_SERVER_ERROR',
          400,
          response.error,
          response.validation,
        );
      }
      
      return response;
    },
    enabled: !!organizationId,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}


